(function (doc, win) {
    var htmlDOM = doc.documentElement,
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function () {
            var clientWidth = htmlDOM.clientWidth;
            if (!clientWidth) return;
            if (clientWidth >= 750) {
                htmlDOM.style.fontSize = '100px';
            } else {
                htmlDOM.style.fontSize = 100 * (clientWidth / 750) + 'px';
            }
        };
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);

// orientationchange  移动端方向改变事件
// resize  浏览器窗口大小改变事件
// DOMContentLoaded 事件 在文档完全加载及解析便触发(无需等待CSS文件、图片和子框架加载完毕)